'use client'

import { useEffect, useState } from 'react'
import Link from 'next/link'
import { ShoppingCart } from 'lucide-react'
import { useCartStore } from '@/store/cart-store'

export default function FloatingCartButton() {
  const itemCount = useCartStore((s) => s.getItemCount())
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  // SSR 时始终渲染一致的 DOM（hidden + 无角标），客户端 mount 后更新
  return (
    <Link
      href="/cart"
      className={!mounted || itemCount === 0
        ? 'hidden'
        : 'fixed right-4 bottom-20 z-50 flex items-center justify-center w-12 h-12 bg-pink-500 rounded-full shadow-lg hover:bg-pink-600 active:scale-95 transition-all'}
    >
      <ShoppingCart className="w-5 h-5 text-white" />
      {mounted && itemCount > 0 && (
        <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center">
          {itemCount > 99 ? '99+' : itemCount}
        </span>
      )}
    </Link>
  )
}
